module.exports = __webpack_public_path__ + "static/media/shop_type_2.e0b9113a.png";